import { SxProps, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { currencyToNumber, maskCurrency } from '../../utils/maks'
import { useTranslation } from 'react-i18next'

interface Props {
    value: number
    setValue(v: number): void
    label: string
    sx?: SxProps
    error?: string
    onClick?(): void
    size?: 'small' | 'medium'
    maxValue?: number
}

export const DistanceField = ({
    value,
    setValue,
    label,
    sx,
    error,
    onClick,
    size,
    maxValue,
}: Props) => {
    const { t } = useTranslation()
    const [localValue, setLocalValue] = useState('')

    useEffect(() => {
        setLocalValue(maskCurrency(value, undefined, 0))
    }, [value])

    return (
        <TextField
            sx={{
                ...sx,
            }}
            error={Boolean(error)}
            helperText={error}
            onClick={onClick}
            value={localValue}
            label={t(label)}
            onChange={(e) => {
                let { value } = e.target
                value = value.replace(/\D/g, '')
                const numberValue = Number(value)
                if (maxValue && numberValue > maxValue) return
                setValue(numberValue)
            }}
            InputProps={{
                endAdornment: (
                    <Typography
                        sx={{
                            mr: '2px',
                            whiteSpace: 'nowrap',
                            fontSize: '14px',
                        }}
                    >
                        km
                    </Typography>
                ),
            }}
            size={size}
        />
    )
}
